module.exports = __webpack_public_path__ + "static/media/industries-glass-s.d12db852.webp";